import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ children, loggedIn, ...rest }) => (
    <Route {...rest} children={props => {
        if (!loggedIn) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: process.env.PUBLIC_URL + "/login", state: { from: props.location } }} />
        }

        console.log(children)
        // authorised so return component
        return children 
    }} />
)

export default PrivateRoute;